
import React from 'react';
import {
  Box,
  Button,
  Chip,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import { 
  Link 
} from '@backstage/core-components';
import {
  ResultHighlight,
} from '@backstage/plugin-search-common';
import { 
  HighlightedSearchResultText 
} from '@backstage/plugin-search-react';
import { 
  TEpDevPTag,
  IEpDevPManagedAssetIndexableDocument
} from '@solace-labs/backstage-plugin-ep-devp-common';
import { 
  IEpDevPSearchPageSelectItem 
} from './EpDevPSearchPageControl';
import { useServiceRegistryTranslation } from '../../../../i18n/ServiceRegistryLanguageProvider';


const useStyles = makeStyles({
  flexContainer: {
    flexWrap: 'wrap',
  },
  itemText: {
    width: '100%',
    wordBreak: 'break-all',
    marginBottom: '1rem',
  },
});

export interface IEpDevPSearchResultListItemProps {
  icon?: React.ReactNode;
  result: IEpDevPManagedAssetIndexableDocument;
  highlight?: ResultHighlight;
  rank?: number;
  selectItem?: IEpDevPSearchPageSelectItem;
}

export const EpDevPSearchResultListItem: React.FC<IEpDevPSearchResultListItemProps> = (props: IEpDevPSearchResultListItemProps) => {
  const { t } = useServiceRegistryTranslation();

  const result = props.result;

  const classes = useStyles();

  const onSelectItemClick = () => {
    if(props.selectItem) props.selectItem.onSelect({
      assetEntityId: result.epDevPManagedAsset.entityId,
      domainId: result.epDevPManagedAsset.epDevPDomainInfo.owningDomainEntityId.id
    })
  }

  const getLinkTo = () => {
    if(props.selectItem) return '#';
    return result.location;
  }

  const renderResult = () => {
    return (
      <Link noTrack to={getLinkTo()} onClick={onSelectItemClick}>
        <ListItem alignItems="flex-start">
          {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
          <div className={classes.flexContainer}>
            <ListItemText
              className={classes.itemText}
              primaryTypographyProps={{ variant: 'h6' }}
              primary={
                props.highlight?.fields.title ? (
                  <HighlightedSearchResultText
                    text={props.highlight.fields.title}
                    preTag={props.highlight.preTag}
                    postTag={props.highlight.postTag}
                  />
                ) : (
                  result.title
                )
              }
              secondary={
                props.highlight?.fields.text ? (
                  <HighlightedSearchResultText
                    text={props.highlight.fields.text}
                    preTag={props.highlight.preTag}
                    postTag={props.highlight.postTag}
                  />
                ) : (
                  result.text
                )
              }
            />
            <Box>
              {result.epDevPManagedAsset.tags.map( (tag: TEpDevPTag) => {
                return <Chip key={tag.label} label={`${tag.label}: ${tag.value}`} size="small" />
              })}
              {result.epDevPManagedAsset.epCustomTags.map( (tag: TEpDevPTag) => {
                return <Chip key={tag.label} label={`${tag.label}: ${tag.value}`} size="small" />
              })}
            </Box>
            {/* DEBUG */}
            {/* <Box>
              <pre>{JSON.stringify(result, null, 2)}</pre>
            </Box> */}
          </div>
        </ListItem>
      </Link>
    );
  }

  return (
    <Box>
      { renderResult() }
      { props.selectItem && 
        <Button
          variant="contained"
          onClick={onSelectItemClick}
        >
          {t('developerSearch.requestAccess')}
        </Button>    
      }
      <Divider component="li" />
    </Box>
  );
}
